import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TelemetryService {

  Tag: string;
  dongleUId: string;
  cooler_lastConnectedOn: string;
  cooler_name: string;
  controllerTypeName: string;
  cooler_isWireless: boolean;
  cooler_id: number;
  cooler_mask: string;
  cooler_poli: string;
  cooler_firmwareVersion: string;
  cooler_controllerTypeId: number;

  

  setData(tag: string, last_connected_on: string, controllerTypeName: string, dongleUId: string, cooler_name: string, isWireless: boolean,
    id: number, mask: string, poli: string, firmwareVersion: string, controllerTypeId: number) {

    this.Tag = tag;
    this.cooler_lastConnectedOn = last_connected_on;
    this.controllerTypeName = controllerTypeName;
    this.dongleUId = dongleUId;
    this.cooler_name = cooler_name;
    this.cooler_isWireless = isWireless;
    this.cooler_id = id;
    this.cooler_mask = mask;
    this.cooler_poli = poli;
      this.cooler_firmwareVersion = firmwareVersion;
    this.cooler_controllerTypeId = controllerTypeId

  }
}
